import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { HelperService } from '../helper.service';




const ITEM_WIDTH = 232;

@Component({
  selector: 'app-home-screen-new',
  templateUrl: './home-screen-new.component.html',
  styleUrls: ['./home-screen-new.component.scss']
})
export class HomeScreenNewComponent implements OnInit {

  specialityCategoryList$: Observable<any[]>
  
  constructor(
    private apiService: ApiService,
    private router: Router
  ) {

  }

  ngOnInit(): void {
    this.specialityCategoryList$ = this.apiService.getSpecialityCategory({}) as Observable<any[]>;
  }

  searchByClassType(id: number) {
    this.router.navigate([`search-class-results` + `/` + id], { queryParams: { mode: '' } });
  }

}


